import { connect } from 'react-redux';
import ConstructorLandings from './ConstructorLandings'

const ConstructorLandingsComponent = connect(
    function mapStateToProps(state, {visible, landing, onClose, onSave}) {
        return {
            goalEntries: state.goalEntries.list,
            publisherId: state?.user?.publisher?.id || '',
            offer: state.offers.list[0],
            links: state.links.list,
            landing: landing,
            visible: visible,
            onClose: onClose,
            onSave: onSave
        };
    },
    function mapDispatchToProps() {
        return {};
    }
)(ConstructorLandings);

export default ConstructorLandingsComponent;
